// Single source of truth for the appointment table column set used by
// Today (DayView), Upcoming-Tomorrow, Upcoming-Future, and History.
//
// The 19 columns and their ids/order are identical across all four views.
// Only the "status" column's LABEL and the FIELD it reads change per view
// (Today/History show "Day's Outcome" = appointment_day_outcome;
//  Tomorrow/Future show "Booking Status" = appointment_status). The label
// is applied via getAppointmentColumns(statusLabel); the field is chosen
// by each page's renderer.

export const DEFAULT_APPOINTMENT_COLUMNS = [
  { id: "time", label: "Time" },
  { id: "source", label: "Source" },
  { id: "customer_name", label: "Customer Name" },
  { id: "phone", label: "Ph. No" },
  { id: "mail_id", label: "Mail ID" },
  { id: "reg_no", label: "Reg No" },
  { id: "vin", label: "VIN" },
  { id: "model", label: "Model" },
  { id: "current_km", label: "Current KM" },
  { id: "ots", label: "OTS" },
  { id: "service_type", label: "Service Type" },
  { id: "sa_name", label: "SA Name" },
  { id: "docket_readiness", label: "Docket Readiness" },
  { id: "n1", label: "N-1" },
  { id: "status", label: "Day's Outcome" },
  { id: "cre_name", label: "CRE Name" },
  { id: "lost_customer", label: "Lost Customer" },
  { id: "remarks", label: "Remarks" },
  { id: "actions", label: "" },
];

// Columns that can be hidden via "Customize Columns" (same set across all views).
export const CUSTOMIZABLE_APPOINTMENT_COLUMN_IDS = [
  "mail_id",
  "docket_readiness",
  "n1",
  "cre_name",
];

// Returns the 19-column definitions with the "status" column's label overridden
// (e.g. "Day's Outcome" on Today/History, "Booking Status" on Tomorrow/Future).
export function getAppointmentColumns(statusLabel = "Day's Outcome") {
  return DEFAULT_APPOINTMENT_COLUMNS.map((c) =>
    c.id === "status" ? { ...c, label: statusLabel } : c
  );
}
